document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const config = {
    width: 560,
    height: 315,
    containerClass: 'youtube-embed-container',
    allowFullscreen: true
  };

  // Function to extract YouTube video ID from various URL formats
  function extractVideoId(url) {
    const patterns = [
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/i,    // Standard URL
      /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([^?]+)/i,               // Shortened URL
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([^?]+)/i      // Embed URL
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }
    return null;
  }

  // Function to create embed iframe
  function createEmbed(videoId) {
    const container = document.createElement('div');
    container.className = config.containerClass;
    container.style.cssText = 'position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; margin: 20px 0;';

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}`;
    iframe.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%;';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    
    if (config.allowFullscreen) {
      iframe.setAttribute('allowfullscreen', '');
    }

    container.appendChild(iframe);
    return container;
  }

  // Function to process content and replace YouTube links
  function processContent() {
    // Find all text nodes in the body
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const nodesToProcess = [];
    let node;
    while (node = walker.nextNode()) {
      // Skip nodes in scripts and style elements
      if (node.parentNode.tagName === 'SCRIPT' || node.parentNode.tagName === 'STYLE') {
        continue;
      }
      nodesToProcess.push(node);
    }

    // Process each text node
    nodesToProcess.forEach(textNode => {
      const content = textNode.textContent;
      const lines = content.split('\n');
      let hasYouTubeLink = false;

      lines.forEach((line, index) => {
        const videoId = extractVideoId(line.trim());
        if (videoId) {
          hasYouTubeLink = true;
          lines[index] = ''; // Remove the URL
          // Insert embed after the empty line
          const embed = createEmbed(videoId);
          textNode.parentNode.insertBefore(embed, textNode.nextSibling);
        }
      });

      if (hasYouTubeLink) {
        // Update text content without the YouTube URLs
        textNode.textContent = lines.join('\n').replace(/\n{3,}/g, '\n\n');
      }
    });
  }

  // Add CSS for responsive video containers
  const style = document.createElement('style');
  style.textContent = `
    .${config.containerClass} {
      background-color: #f8f8f8;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    .${config.containerClass} iframe {
      border-radius: 8px;
    }
  `;
  document.head.appendChild(style);

  // Run the processor
  processContent();
});